import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import IntelHeader from "./intel-header";
import LocalStorageService from "@core/services/local-storage.service";
import Sidebar from "./sidebar";
import HermesFloatingButton from "./HermesFloatingButton";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import Supademo from "@routes/intel/onboarding-screens/onboarding/Supademo";
import { handlePatch } from "@routes/intel/onboarding-screens/onboarding/utils";
import GetInTouchLimit from "@components/templates/GetInTouchLimit/GetInTouchLimit";
import { profileTypeEnum } from "@containers/CompanyProfile/utils/enum.js";
import ProductOnboarding from "../../routes/intel/ProductOnboarding/ProductOnboarding";
import { useSelector } from "react-redux";
import { BRAND } from "@core/brand/brand-config";

const brandizeTitle = (title) => (typeof title === "string" ? title.replace(/Trademo Intel/g, BRAND.titleSuffix) : title);

function IntelLayout(props) {
  const localStorageService = LocalStorageService.getService();
  const [userPlan, setUserPlan] = useState();
  const [sideBarOpen, setSideBarOpen] = useState(true);
  const [showGlobalPrimarySearchCard, setShowGlobalPrimarySearchCard] = useState(false);
  const notificationData = localStorageService.getnotificationData();
  const [currOnboardingObj, setCurrOnboardingObj] = useState("");
  const [onboardingInitiator, setOnboardingInitiator] = useState();
  const [onboardingData, setOnboardingData] = useState();
  const [showGetInTouch, setShowGetInTouch] = useState(false);
  const userDetails = useSelector((state) => state.userDetails);
  //change the below to 'false'
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const [showOnboardingPopup, setShowOnboardingPopup] = useState(userDetails?.userData?.show_onboarding_popup ?? false);
  const [showDuePayment, setShowDuePayment] = useState(false);

  useEffect(() => {
    if (props.sidebarRef) props.sidebarRef.current = setSideBarOpen;
  });

  // The landing page mounts this layout before the profile API resolves, so the flag has to be synced, not just seeded
  useEffect(() => {
    if (userDetails?.userData?.show_onboarding_popup) {
      setShowOnboardingPopup(true);
    }
  }, [userDetails?.userData?.show_onboarding_popup]);

  const getUserDetails = (data) => {
    if (props.userDetails) {
      props.userDetails(data);
    }
  };
  const callNudgeHandler = (data, event) => {
    if (props.callNudgeHandler) {
      props.callNudgeHandler(data, event);
    }
  };
  const showMultiCountryTopNudge = (data) => {
    if (props.setShowMultiCountryTopNudge) {
      props.setShowMultiCountryTopNudge(data);
    }
  };
  const setIntelHeaderDataSource = (data) => {
    if (props.setIntelHeaderDataSource) {
      props.setIntelHeaderDataSource(data);
    }
  };
  const setPlanId = (data) => {
    if (props.setPlanId) {
      props.setPlanId(data);
    }
  };
  const hsCodeApplyCalled = (e, type) => {
    if (props.hsCodeApplyCalled) {
      props.hsCodeApplyCalled(e, type);
    }
  };
  const setDataSourceOption = (data) => {
    if (props.setDataSourceOption) {
      props.setDataSourceOption(data);
    }
  };
  const setCurrentProduct = (data) => {
    if (props.setCurrentProduct) {
      props.setCurrentProduct(data);
    }
  };
  const setUserProductAccess = (data) => {
    if (props?.setUserProductAccess) {
      props.setUserProductAccess(data);
    }
  };
  const fetchDataSourceInfo = (data) => {
    if (props.fetchDataSourceInfo) {
      props.fetchDataSourceInfo(data);
    }
  };

  const updatingOnboardingData = (data) => {
    setOnboardingData(data);
  };
  const handleSetCurrOnboarding = (e, trigger) => {
    setCurrOnboardingObj(e);
    setOnboardingInitiator(trigger);
  };
  const handleGetInTouchOpen = () => {
    setShowGetInTouch(true);
  };
  const handleGetInTouchClose = () => {
    setShowGetInTouch(false);
  };

  if (showOnboardingPopup && creditDetails?.data?.length) {
    return <ProductOnboarding setShow={setShowOnboardingPopup} />;
  }

  return (
    <div className={`tw-flex tw-max-w-full ${showDuePayment ? "tw-flex-col" : ""}`}>
      {props.pageTitle && (
        <Helmet>
          <title>{brandizeTitle(props.pageTitle)}</title>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
      {showDuePayment && (
        <div className="tw-min-h-10 tw-bg-white tw-flex tw-items-center tw-justify-center tw-h-16 tw-fixed tw-top-0 tw-z-[1000] tw-w-full">
          <span className="tw-border tw-border-[#f8924a] tw-rounded-xl tw-bg-[#fff6f0] tw-text-sm tw-font-medium tw-flex tw-items-center tw-h-12 tw-w-full tw-mx-4 tw-py-3 tw-pl-8 tw-pr-4 tw-gap-4 tw-justify-between">
            <span className="tw-flex tw-items-center tw-gap-4">
              <span className={`material-symbols-outlined`}>warning</span>
              <span className="tw-flex tw-gap-1">
                It seems your last payment didn't go through. Please complete your payment. Contact{" "}
                <a href="mailto:support@trademo.com" className="tw-text-sm tw-font-semibold !tw-underline">
                  support@trademo.com
                </a>{" "}
                if you need assistance.
              </span>
            </span>
            <span className="tw-flex tw-mr-8">
              <span className="tw-flex tw-gap-1 tw-cursor-pointer tw-bg-primary-purple-500 tw-text-white tw-border-none tw-rounded-lg tw-w-fit tw-text-sm tw-font-semibold tw-px-4 tw-py-2" onClick={() => window.open(notificationData.data?.due_payment_details?.invoice_url, "_blank")}>
                Pay now
              </span>
            </span>
          </span>
        </div>
      )}
      <div
        onClick={() => {
          if (props.setNotification) {
            props.setNotification(false);
          }
        }}>
        <Sidebar callingTrackingEvents={props.callingTrackingEvents} searchedItem={props.searchedItem} isDateChanged={props.isDateChanged} isSearchButtonCalled={props.isSearchButtonCalled} appliedFilter={props.appliedFilter} checkforFilters={props.checkforFilters} planId={props.planId} userPlan={userPlan} intelHeaderDataSource={props.intelHeaderDataSource} type={props.type} setSideBarOpen={setSideBarOpen} sideBarOpen={sideBarOpen} handleNudgePopup={props.handleNudgePopup ? (event, key) => props.handleNudgePopup(event, key) : null} {...props} />
      </div>
      <div className={`tw-flex tw-flex-col tw-flex-grow tw-transition-all tw-duration-300 tw-ease-in-out tw-w-[82%] ${sideBarOpen ? "tw-ml-[230px]" : "tw-ml-20"}`}>
        <IntelHeader
          setNotification={(val) => {
            if (props.setNotification) {
              props.setNotification(val);
            }
          }}
          showNotification={props.showNotification}
          handleNudgePopup={props.handleNudgePopup ? (event, key) => props.handleNudgePopup(event, key) : null}
          getUserDetails={(e) => getUserDetails(e)}
          callNudgeHandler={(val, event) => callNudgeHandler(val, event)}
          setCountry={(val) => {
            if (props.setCountry) {
              props.setCountry(val);
            }
          }}
          notificationData={notificationData}
          hsCodeApplyCalled={(e, type) => hsCodeApplyCalled(e, type)}
          nudgePopupStateObj={props.nudgePopupStateObj}
          showMultiCountryTopNudge={(val) => showMultiCountryTopNudge(val)}
          setPlanId={(val) => setPlanId(val)}
          setUserPlan={(val) => {
            if (props.setUserPlan) {
              props.setUserPlan(val);
            }
          }}
          setPlan={setUserPlan}
          setIntelHeaderDataSource={(val) => setIntelHeaderDataSource(val)}
          setDataSourceOption={(val) => setDataSourceOption(val)}
          setCurrentProduct={(val) => setCurrentProduct(val)}
          setUserProductAccess={(val) => setUserProductAccess(val)}
          fetchDataSourceInfo={(val) => fetchDataSourceInfo(val)}
          sideBarOpen={sideBarOpen}
          type={props?.type ?? ""}
          pageLabel={props?.pageLabel}
          showGlobalPrimarySearchCard={showGlobalPrimarySearchCard}
          setShowGlobalPrimarySearchCard={setShowGlobalPrimarySearchCard}
          handleGetInTouchOpen={() => (props?.handleGetInTouchOpen ? props?.handleGetInTouchOpen() : handleGetInTouchOpen())}
          country={props?.country}
          handleSetCurrOnboarding={(e, trigger, data) => (props?.handleSetCurrOnboarding ? props?.handleSetCurrOnboarding(e, trigger, data) : handleSetCurrOnboarding(e, trigger))}
          updatingOnboardingData={(val) => (props?.updatingOnboardingData ? props?.updatingOnboardingData(val) : updatingOnboardingData(val))}
          showGetInTouch={props?.showGetInTouch ? props?.showGetInTouch : showGetInTouch}
          handleGetInTouchClose={() => (props.handleGetInTouchClose ? props.handleGetInTouchClose() : handleGetInTouchClose())}
          setShowDuePayment={setShowDuePayment}
          showDuePayment={showDuePayment}
        />
        <main className={`tw-flex-grow ${showDuePayment ? "tw-mt-28" : "tw-mt-12"} ${["resourceCenter", "companySearch", "productSearch", "companyProfile", "intelHub", "workspace", "hermes"].includes(props?.type) ? "" : "tw-px-5"}`}>{props?.children}</main>
        {/* <main className={`tw-flex-grow tw-mt-12 ${(props.country === "multicountry" || props.country === "global data") && isEnterpriseUser && isTrademoUser ? "tw-pl-3 tw-pr-9" : "tw-px-5"}`}>{props?.children}</main> */}
      </div>

      {currOnboardingObj !== "" && (
        <Supademo
          comingFrom="companyProfile"
          onboardingInitiator={onboardingInitiator}
          onboardingData={onboardingData ? onboardingData : []}
          type="modal"
          url={onboardingData ? onboardingData.onboarding_details[currOnboardingObj].supademoUrl : []}
          modalHeading={onboardingData ? onboardingData.onboarding_details[currOnboardingObj].title : []}
          description={onboardingData ? onboardingData.onboarding_details[currOnboardingObj].brief : []}
          currOnboardingObj={currOnboardingObj ? currOnboardingObj : ""}
          handleSetCurrOnboarding={(e, trigger, data) => handleSetCurrOnboarding(e, trigger, data)}
          updatingOnboardingData={(val) => updatingOnboardingData(val)}
          closeModal={() => {
            if (!onboardingData?.onboarding_details[currOnboardingObj]?.isViewed) {
              handlePatch("onboarding", currOnboardingObj);
            }
            setCurrOnboardingObj("");
            if (props?.callingTrackingEvents) {
              props?.callingTrackingEvents(trackingEventDictionary.onboardingCancelIcon);
            }
          }}
          checkPendoEventForCompanyRedirection={props?.callingTrackingEvents}
        />
      )}
      {showGetInTouch ? <GetInTouchLimit showGetInTouchPopup={showGetInTouch} handleGetInTouchClose={() => (props.handleGetInTouchClose ? props.handleGetInTouchClose() : handleGetInTouchClose())} profileType={profileTypeEnum.company} notifyCountry={props.country} blockAccessType={"connect"} /> : null}
      {props?.type !== "hermes" && <HermesFloatingButton />}
    </div>
  );
}

export default React.memo(IntelLayout);
